import { z } from "zod";
export const VideoTagSchema = z.enum(["癒やし", "学び"]);
export const VideoEntrySchema = z.object({
    videoId: z.string(),
    title: z.string(),
    channelId: z.string(),
    channelName: z.string(),
    publishedAt: z.string(),
    thumbnailUrl: z.string(),
    description: z.string(),
    tags: z.array(VideoTagSchema),
});
export const VideoEntriesSchema = z.array(VideoEntrySchema);
